export default {
  headerCell: {
    backgroundColor: 'none',
  },
};
